<template>
    <section ref="section">

        <div class="top-header text-center">
            <img src="images/logo.png" alt="">
        </div>

        <div class="modal fade" id="modals-ig" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header justify-content-center">
                        <h5 class="modal-title">
                            IG帳號
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div v-if="ig_account_null" class="alert alert-danger" role="alert">
                            請先輸入IG帳號
                        </div>
                        <div class="form-group">
                            <label for="ig_account" class="form-label">IG帳號</label>
                            <input id="ig_account" class="form-control" type="text" name="ig_account" v-model="ig_account"/>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center align-items-center">
                        <button type="button" class="btn btn-primary" @click="check_ig()">確認</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="canvas-wrapper container">
            <div class="d-flex justify-content-center flex-column">
                <div class="canvas-border">
                    <div id="canvas" ref="canvas">
                        <div id="bg">
                            <img :src="bg ? bg : placeholder" alt="">
                        </div>
                        <div id="frame" v-show="frame" :style="'background-image:url(\'' + frame + '\')'">
                            <img :src="frame" alt="">
                        </div>
                        <div id="sticker1" class="sticker" v-show="sticker1" :style="'background-image:url(\'' + sticker1 + '\')'">
                            <span @click="remove_sticker(1);"><i class="fa fa-times"></i></span>
                            <img :src="sticker1" alt="">
                        </div>
                        <div id="sticker2" class="sticker" v-show="sticker2" :style="'background-image:url(\'' + sticker2 + '\')'">
                            <span @click="remove_sticker(2);"><i class="fa fa-times"></i></span>
                            <img :src="sticker2" alt="">
                        </div>
                    </div>
                </div>
                <input type="file" id="file" accept="image/*"/>
                <button type="button" class="btn btn-pink" @click="upload_image()">{{ bg ? '更換照片' : '開始製作' }}</button>
                <div v-if="!bg" class="text-center intro-text">
                    歡迎參加 #天天有專科 創意照活動~<br>
                    請按「開始製作」上傳照片，<br>
                    並選擇你喜歡的外框和貼圖，製作屬於你的專科創意照！<br>
                    完成後，記得下載照片喔！<br>
                    ❤️<strong>貼心小提醒</strong>❤️<br>
                    請以正方形照片為主上傳，照片才不會被切掉喔<br>
                    <span style="color: #0088cc"><strong>#天天有專科</strong></span> <br>
                    <br>
                    <strong>★發揮你的創意 分享美照抽好禮(共3名)★</strong><br>
                    凡2021/ 2/24-3/24 於IG上傳此活動頁產出的專科創意照，<br>
                    只要設公開並 <span style="color: #0088cc"><strong>#天天有專科</strong></span> 即可抽「專科大禮包」<br>
                    (內容有專科潔顏乳3款+專科面膜*6款+專科星空瓶+專科奶肌卸妝水+專科亮顏霜+專科爆水凝露)<br>

                </div>
            </div>
        </div>
        <div class="modal fade" id="frameModal" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header justify-content-center">
                        <h5 class="modal-title">
                            請選擇外框
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="i in 3" class="frame-item" :class="tmp_frame === 'frame' + i ? 'active' : ''" @click="select_frame('frame' + i)">
                            <img :src="'images/frame' + i + '.png'" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center align-items-center">
                        <button type="button" class="btn btn-primary btn-agree" @click="update_frame()">確定</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="stickerModal" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header justify-content-center">
                        <h5 class="modal-title">
                            請選擇貼圖
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-4" v-for="i in 5">
                                <div class="sticker-item" :class="tmp_sticker1 === 'sticker' + i || tmp_sticker2 === 'sticker' + i ? 'active' : ''" @click="select_sticker('sticker' + i)">
                                    <img :src="'images/sticker' + i + '.png'" alt="" class="img-fluid" width="200">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center align-items-center">
                        <button type="button" class="btn btn-primary btn-agree" @click="update_sticker()">確定</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="controller" v-show="bg">
            <div class="row no-gutters">
                <div class="col">
                    <div class="control-btn" data-toggle="modal" data-target="#frameModal">
                        <i class="far fa-square"></i>
                        外框
                    </div>
                </div>
                <div class="col">
                    <div class="control-btn" data-toggle="modal" data-target="#stickerModal">
                        <i class="fas fa-heart"></i>
                        貼圖
                    </div>
                </div>
                <div class="col">
                    <div class="control-btn last" @click="generatorImage()">
                        <i class="fas fa-check"></i>
                        完成
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';

export default {
    data: function () {
        return {
            ig_account: null,
            ig_account_null: false,
            placeholder: 'images/placeholder.jpg',
            bg: null,
            tmp_frame: null,
            frame: null,
            tmp_sticker1: null,
            tmp_sticker2: null,
            sticker1: null,
            sticker2: null,
            drag_active: false,
            initialX: 0,
            initialY: 0,
        }
    },
    mounted: function () {
        let self = this;

        $("#file").change(function () {
            if (this.files && this.files[0]) {
                let reader = new FileReader();

                reader.onload = function (e) {
                    self.bg = e.target.result;
                }

                reader.readAsDataURL(this.files[0]); // convert to base64 string
            }
        });

        $("#sticker1").bind('mousedown touchstart', function (e) {
            $(this).data('move', true);
            self.dragStart(e, this, 1);
        }).bind('mouseup touchend', function (e) {
            $(this).data('move', false);
            self.dragEnd(e, this, 1);
        }).bind('mousemove touchmove', function (e) {
            if ($(this).data('move') === true) {
                self.drag(e, this, 1);
            }
        });

        $("#sticker2").bind('mousedown touchstart', function (e) {
            $(this).data('move', true);
            self.dragStart(e, this, 2);
        }).bind('mouseup touchend', function (e) {
            $(this).data('move', false);
            self.dragEnd(e, this, 2);
        }).bind('mousemove touchmove', function (e) {
            if ($(this).data('move') === true) {
                self.drag(e, this, 2);
            }
        });

        $('#ig_account').on('change', function (e) {
            self.ig_account_null = false;
        });

        $(window).on('load', function () {
            $('#modals-ig').modal('show');
        });
    },
    methods: {
        check_ig() {
            if (this.ig_account !== null) {
                $('#modals-ig').modal('hide');
            } else {
                this.ig_account_null = true;
            }
        },
        upload_image() {
            $("#file").click();
        },
        select_frame(frame) {
            this.tmp_frame = frame;
        },
        update_frame() {
            this.frame = 'images/' + this.tmp_frame + '@2x.png';
            $("#frameModal").modal('hide');
        },
        select_sticker(sticker) {
            if (this.tmp_sticker1 === null) {
                this.tmp_sticker1 = sticker;
            } else if (this.tmp_sticker1 === sticker) {
                this.tmp_sticker1 = null;
            } else if (this.tmp_sticker2 === null) {
                this.tmp_sticker2 = sticker;
            } else if (this.tmp_sticker2 === sticker) {
                this.tmp_sticker2 = null;
            } else {
                return false;
            }
        },
        update_sticker() {
            this.sticker1 = this.tmp_sticker1 ? 'images/' + this.tmp_sticker1 + '@2x.png' : null;
            this.sticker2 = this.tmp_sticker2 ? 'images/' + this.tmp_sticker2 + '@2x.png' : null;
            $("#stickerModal").modal('hide');
        },
        remove_sticker(number) {
            if (number === 1) {
                this.sticker1 = null;
                this.tmp_sticker1 = null;
            } else {
                this.sticker2 = null;
                this.tmp_sticker2 = null;
            }
        },
        dragStart(e, element) { //when the drag starts
            let xOffset = $(element).data('xOffset') ? $(element).data('xOffset') : 0;
            let yOffset = $(element).data('yOffset') ? $(element).data('yOffset') : 0;

            if (e.type === "touchstart") { //if its a touchscreen
                this.initialX = e.touches[0].clientX - xOffset; //set initial x-cordinate to where it was before drag started
                this.initialY = e.touches[0].clientY - yOffset; //set initial y-cordinate to where it was before drag started
            } else { //if its not a touchscreen (mouse)
                this.initialX = e.clientX - xOffset; //set initial x-cordinate to where it was before drag started
                this.initialY = e.clientY - yOffset; //set initial y-cordinate to where it was before drag started
            }
            if (e.target === element) { //if user is dragging circle
                this.drag_active = true; //the drag is active
            }
        },
        dragEnd(e, element) { //when the drag ends
            this.drag_active = false; //the drag is no longer active
        },
        drag(e, element) { //when the circle is being dragged
            if (this.drag_active) { //if the drag is active
                e.preventDefault(); //the user cant do anything else but drag

                let currentX = 0;
                let currentY = 0;

                if (e.type === "touchmove") { //if its a touchscreen
                    currentX = e.touches[0].clientX - this.initialX; //set current x-cordinate to where it is now
                    currentY = e.touches[0].clientY - this.initialY; //set current y-cordinate to where it is now
                } else { //if its not a touchscreen (mouse)
                    currentX = e.clientX - this.initialX; //set current x-cordinate to where it is now
                    currentY = e.clientY - this.initialY; //set current y-cordinate to where it is now
                }

                $(element).data('xOffset', currentX);
                $(element).data('yOffset', currentY);

                this.setTranslate(currentX, currentY, element);
            }
        },
        setTranslate(xPos, yPos, element) { //Im not sure what this does but it dosnt work without it
            element.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
        },
        generatorImage() {
            let self = this;
            this.loading();
            $('#frame, .sticker').css('background', 'none');
            $('.sticker span').hide();
            $('#frame img').show();
            $('.sticker img').show();
            html2canvas(this.$refs.canvas, {
                scale: 2,
                dpi: 300,
            }).then(canvas => {
                this.$refs.section.append(canvas);

                let formData = new FormData();
                let img = canvas.toDataURL('image/png', 1);

                formData.append("image", img);
                formData.append("ig_account", self.ig_account);

                axios.post('api/post', formData)
                .then((res) => {
                    this.endloading();

                    let link = document.createElement("a");
                    document.body.appendChild(link);
                    link.download = "download";
                    link.href = img;
                    link.target = '_blank';
                    link.click();

                    Swal.fire({
                        title: '最後一步囉！',
                        icon: 'success',
                        html: '<img src="' + img + '" class="img-fluid p-3"><p class="text-center">❤️長按以下照片就可以儲存❤️</p>',
                        confirmButtonText: '再編輯一張',
                        didClose: () => {
                            window.location.reload()
                        }
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
            })
        },
        loading() {
            let html = '<div class="modal" id="loadingPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">';
            html += '<div class="modal-dialog modal-dialog-centered" role="document">';
            html += '<div class="modal-content">';
            html += '<div class="modal-body"><p class="text-center"><img src="images/loading.gif" alt="" class="loading-gif"></p></div>';
            html += '</div></div></div>';
            $("body").append(html);
            $("#loadingPopup").modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            }).on('hidden.bs.modal', function (e) {
                $(this).remove();
            });
        },
        endloading() {
            $("#loadingPopup").modal("hide");
        }
    }
}
</script>
